import { render, staticRenderFns } from "./ComprobanteContableDetallePage.vue?vue&type=template&id=40c0ac90"
import script from "./ComprobanteContableDetallePage.js?vue&type=script&lang=js&external"
export * from "./ComprobanteContableDetallePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports